import { render } from "./AccountSettingsContent.vue?vue&type=template&id=35080e6a&scoped=true"
import script from "./AccountSettingsContent.vue?vue&type=script&lang=js"
export * from "./AccountSettingsContent.vue?vue&type=script&lang=js"

import "./AccountSettingsContent.vue?vue&type=style&index=0&id=35080e6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35080e6a"

export default script